import { Box, Typography, Link } from '@mui/material'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    padding: '50px',
    gap: '20px'
  },
  title: {
    fontWeight: 'bold'
  }
}

export const VendorInsights = () => {
  return (
    <Box sx={styles.container} data-testid="vendor-insights">
      <Typography variant="h5" sx={styles.title}>
        Gain Meaningful Brand Exposure
      </Typography>

      <Typography variant="body1">
        We guarantee native content placements to help brands engage with their
        target customers — right on the publications they visit every day.
      </Typography>

      <Typography variant="body1">
        Contact Us For More Information -{' '}
        <Link
          href="mailto:advertising@stackcommerce.com"
          target="_blank"
          rel="noreferrer"
        >
          advertising@stackcommerce.com
        </Link>
      </Typography>
    </Box>
  )
}
